import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/andrew/workspace/react-see-through/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { useState } from 'react';
import { Playground, Props } from 'docz';
import SeeThrough from './SeeThrough';
import SeeThroughController from './SeeThroughController';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "seethroughcontroller"
    }}>{`SeeThroughController`}</h1>
    <p>{`This component is necessary if you want to have multiple active SeeThroughs at once`}</p>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={SeeThroughController} isToggle={true} mdxType="Props" />
    <h2 {...{
      "id": "importing"
    }}>{`Importing`}</h2>
    <p>{`To use the SeeThroughController, you want to do:`}</p>
    <code>
  {`import { SeeThroughController } from 'react-see-through';`}
    </code>
    <p>{`after installing.`}</p>
    <h2 {...{
      "id": "multiple-active-seethroughs-at-once"
    }}>{`Multiple active SeeThroughs at once`}</h2>
    <h3 {...{
      "id": "differences"
    }}>{`Differences:`}</h3>
    <ul>
      <li parentName="ul">{`There's a `}<strong parentName="li">{`SeeThroughController`}</strong>{` above all of the related SeeThroughs`}</li>
      <li parentName="ul">{`All of the SeeThroughs' `}<strong parentName="li">{`onClick`}</strong>{` handlers are triggered`}</li>
      <li parentName="ul"><strong parentName="li">{`maskColor`}</strong>{` is now defined on the controller so that it's the same for all SeeThroughs`}</li>
    </ul>
    <Playground __position={2} __code={'() => {\n  const [active, setActive] = useState(false)\n  return (\n    <SeeThroughController maskColor=\"rgba(255, 0, 0, 0.4)\">\n      <div style={{ padding: \'60px\' }}>\n        <SeeThrough\n          active={active}\n          onClick={masked => masked && setActive(false)}\n        >\n          <div>My cool content</div>\n        </SeeThrough>\n        <button onClick={() => setActive(true)}>Activate</button>\n        <SeeThrough\n          active={active}\n          onClick={masked => masked && setActive(false)}\n        >\n          <div>My cool content somewhere else on the page</div>\n        </SeeThrough>\n      </div>\n    </SeeThroughController>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      useState,
      Playground,
      Props,
      SeeThrough,
      SeeThroughController,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const [active, setActive] = useState(false);
        return <SeeThroughController maskColor='rgba(255, 0, 0, 0.4)' mdxType="SeeThroughController">
        <div style={{
            padding: '60px'
          }}>
          <SeeThrough active={active} onClick={masked => masked && setActive(false)} mdxType="SeeThrough">
            <div>My cool content</div>
          </SeeThrough>
          <button onClick={() => setActive(true)}>Activate</button>
          <SeeThrough active={active} onClick={masked => masked && setActive(false)} mdxType="SeeThrough">
            <div>My cool content somewhere else on the page</div>
          </SeeThrough>
        </div>
      </SeeThroughController>;
      }}
    </Playground>
    <hr></hr>
    <h2 {...{
      "id": "when-should-you-have-multiple-active-seethroughs"
    }}>{`When should you have multiple active SeeThroughs?`}</h2>
    <p>{`Suppose that you have a popup that's always in the same position and the popup is associated
with some element on the page:`}</p>
    <p><img alt="A calendar website with an event and a popup both see-through" src={require("../example-multi-mobile.png")} /></p>
    <p>{`In this example there are two active SeeThroughs at the same time: one around the time on the calendar
and one around the drawer at the bottom.`}</p>
    <p>{`This can't be done with one active SeeThrough because both elements are far apart in the DOM and
moving a single SeeThrough high up in the tree would result in almost everything being see through.`}</p>
    <hr></hr>
    <h2 {...{
      "id": "how-do-different-seethroughs-know-their-active-prop-should-be-true-at-the-same-time"
    }}>{`How do different SeeThroughs know their "active" prop should be true at the same time?`}</h2>
    <p>{`You'll need your own way of passing that information to them. Some common ways are through
React contexts or Redux.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      